// extracted by mini-css-extract-plugin
export default {"template-properties-local":"template-properties_template-properties-local__LAVL8"};